import VxeTableComponent from './src/table';
import { dynamicApp } from '../dynamics';
export var VxeTable = Object.assign(VxeTableComponent, {
    install: function (app) {
        app.component(VxeTableComponent.name, VxeTableComponent);
    }
});
export var Table = VxeTable;
dynamicApp.component(VxeTableComponent.name, VxeTableComponent);
export default VxeTable;
